import React from "react";

const DataMonitoringTabs = ({ activeTab, setActiveTab }) => {
  const tabNames = [
    "Data Quality Holistic",
    "Code Quality",
    "SFU Usage Metrics",
    "Cost Monitoring",
    "Platform KPI",
    "Product Usage",
    "Product View"
  ];

  return (
    <div className="dm-tabs">
      {tabNames.map((name, index) => (
        <button
          key={index}
          onClick={() => setActiveTab(index + 1)}
          className={`dm-tab-btn ${activeTab === index + 1 ? "active" : ""}`}
        >
          {name}
        </button>
      ))}
    </div>
  );
};

export default DataMonitoringTabs;
